// UGC Gallery — loads approved community photos from app API
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const grid = document.getElementById('ugc-grid');
    if (!grid) return;

    fetch('/apps/birdie-shots/api/ugc')
      .then(r => r.json())
      .then(data => {
        if (!data.photos || data.photos.length === 0) return;
        grid.innerHTML = data.photos.map(photo => `
          <div class="sticky-note animate-on-scroll">
            <img src="${photo.url}" alt="${photo.caption || 'Community photo'}" loading="lazy">
            ${photo.caption ? `<p class="sticky-note__caption">${photo.caption}</p>` : ''}
          </div>
        `).join('');
        if (window.birdieAnimations) window.birdieAnimations.observe();
      })
      .catch(() => {});
  });
})();
